/**
 * Created by forbiz on 2019-02-11.
 */

const myShippingAddrDetail = () => {
    const $document = $(document);

    // 일반배송 체크 이벤트
    const normalDelivery = () => {
        $document
            .on('click', '.normal-delivery', function() {
                const $this = $(this);
                const $checkInput = $this.children('input[name=deliveryNormal]');
                const $dawnDeliveryInfo = $('.dawnDelivery-info');
                const $dawnDeliveryDesc = $('.dawnDelivery--desc');
                const $dawnDeliveryDescType2 = $('.dawnDelivery--desc-type2');
                
                if ( $checkInput.prop('checked') == true ) {
                    $this.addClass('on');
                    $dawnDeliveryInfo.hide();
                    $dawnDeliveryDesc.hide();
                    $dawnDeliveryDescType2.show();
                } else {
                    $this.removeClass('on');
                    $dawnDeliveryInfo.show();
                    $dawnDeliveryDesc.show();
                    $dawnDeliveryDescType2.hide();
                }
            });
    };

    const dawnDelivery = () => {
        $document
            .on('change', '[name="VISIT_TYPE"]', function() {
                var $this = $(this);
                
                if ( $this.is(':checked') ) {
                    $('.dawnDelivery-info .hd-checkbox-type2').find('[type="text"]').css('visibility', 'hidden').val('');
                    $this.closest('.hd-checkbox-type2').find('[type="text"]').css('visibility', '');
            
                    if ( $('.infobox').find('.alertBox').length > 0 ) {
                        $('.infobox').find('.alertBox').remove();
                    }

                    if ( $('.hd-checkbox-type2').next('.alertBox').length > 0 ) {
                        $('.hd-checkbox-type2').next('.alertBox').remove();
                    }
                }
            });
    };

    const myShippingAddrDetailInit = () => {
        normalDelivery();
        dawnDelivery();
    };
    
    myShippingAddrDetailInit();
};

export default myShippingAddrDetail;